export default function Star({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 51 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.5 0L31.6329 18.6329L50.7553 18.6329L35.0612 30.2342L41.1941 48.8671L25.5 37.2658L9.80594 48.8671L15.9388 30.2342L0.244718 18.6329L19.3671 18.6329L25.5 0Z"
        fill="#FFD700"
        stroke="#FFA500"
        strokeWidth="2"
      />
    </svg>
  );
}
